import styled from 'styled-components';

export const Wrapper = styled.div`
    .link {
        margin-left: 15px;
    }
    h3 {
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 24px;
    }
    h4 {
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        text-transform: capitalize;
    }
`;

export const Title = styled.h1`
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 48px;
`;

export const SubTitle = styled.h2`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 28px;
`;
